import Vue from 'vue'
import store from "@/store"

var DropTaskPromptContent = Vue.extend({
  template: `
  <div>
    <user-drop-task
      ref="userdroptask"
      v-model="config"
      :drag-data="dragData"
      :contact-id="contactId"
      :only-copy-allowed="onlyCopyAllowed"
      @cancel="onCancel" />
  </div>
  `,
  props: {
    dragData: {},
    contactId: {},
    onlyCopyAllowed: {},
  },
  data: () => ({
    config: {}
  }),
  beforeCreate() {
    this.$store = store;
  },
  methods: {
    onCancel() {
      this.reset();
    },
    reset(keep) {
      // Don't reset message, if user clicked on background or accidentally canceled
      this.$refs.userdroptask.reset(keep);
    }
  }
})

export default {
  methods: {
    $task_drop_prompt({ data, contactId, title = null, onlyCopyAllowed = false } = {}) {
      return new Promise((resolve, reject) => {
        this.$msgbox({
          title: title || 'Send task',
          message: this.$createElement(DropTaskPromptContent, {
            props: {
              dragData: data !== null ? data : {
                memberId: null,
                taskId: null,
                goalId: null,
                commitmentId: null,
              },
              onlyCopyAllowed: onlyCopyAllowed,
              contactId: contactId,
            }
          }),
          showCancelButton: true,
          beforeClose: (action, instance, done) => {

            let dataContainer = instance.$children.find( child => 'config' in child )

            let done_with_reset = (keep) => {
              done();
              dataContainer.reset(keep);
            }

            if ( action !== 'confirm' || !dataContainer.config ) {
              done_with_reset(true);
              return
            }

            resolve({
              done: () => done_with_reset(false),
              ...dataContainer._data
            })
          }
        }).catch(e => e);
      })
    }
  }
}

// TODO: Generalize this component
